module.exports = __webpack_public_path__ + "static/use-of-weapons-341b668716940c128cd7584eedbe1e71.jpg";